export const showBackToTop = () => {
  if (window.scrollY >= 700) {
    document.body.classList.add('back-to-top');
  } else {
    document.body.classList.remove('back-to-top');
  }
};

export const handleBackToTop = () => {
  document.getElementById('back-to-top')?.addEventListener('click', () => {
    document.getElementsByClassName('header__brand')[0]?.focus();
  });
};

export const initBackToTop = () => {
  window.addEventListener('scroll', () => {
    showBackToTop();
  });
};
